// extracted by mini-css-extract-plugin
export var disabled = "_d-a";
export var hierarchyLinkGray = "_d-4";
export var hierarchyLinkUnderline = "_d-3";
export var hierarchyPrimary = "_d-0";
export var hierarchySecondary = "_d-1";
export var hierarchyTertiary = "_d-2";
export var pressed = "_d-6";
export var themeAction = "_d-5";
export var themeDestructive = "_d-8";
export var themeNormal = "_d-7";
export var themeSuccess = "_d-9";